import { CompanyStatus } from '@/types'
import { z } from 'zod'

export const getDocumentSchema = (companyStatus: CompanyStatus) => {
  return z.object({
    mainPartner: z.object({
      address: z.array(z.string()).min(1, 'Endereço é obrigatório'),
      personal: z
        .array(z.string())
        .min(1, 'Documentos pessoais são obrigatórios'),
    }),
    company: z.object({
      iptu:
        companyStatus === 'opening_process'
          ? z.array(z.string()).min(1, 'IPTU é obrigatório')
          : z.array(z.string()).optional(),
      company_social_contract:
        companyStatus === 'changing_accountant'
          ? z.array(z.string()).min(1, 'Contrato social é obrigatório')
          : z.array(z.string()).optional(),
    }),
  })
}

export type DocumentsSchemaType = z.infer<ReturnType<typeof getDocumentSchema>>
